// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FundViewOutlinedSvg from "@ant-design/icons-svg/es/asn/FundViewOutlined";
import AntdIcon from '../components/AntdIcon';

var FundViewOutlined = function FundViewOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: FundViewOutlinedSvg
  }));
};

FundViewOutlined.displayName = 'FundViewOutlined';
export default React.forwardRef(FundViewOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/FundViewOutlined.js
// module id = 1243
// module chunks = 0